import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useRef } from 'react'
import { SLowcodeList, SMessage, SSkuCard } from 'shj-components'
import styles from '../../index.module.less'
import { useFileUrlPrefix } from 'shj-utils'
import { deleteByIdAndBudgetId, getListBudgetDtl } from '@/services/order'
import { shortageConfig } from '../../quoteSelection/config'
import { useParams } from 'react-router-dom'
import { isArray } from 'lodash-es'
import { Button, Divider, message } from 'antd'

export default function ShortageProducts(props: any) {
  const { refItemId } = props
  const budgetId = useParams().budgetId
  const tableRef = useRef()
  const fileUrlPrefix = useFileUrlPrefix()

  const tableConfig = {
    ...shortageConfig,
  }
  //   表头render
  const toolbarTitle = (
    <div style={{ display: 'flex', alignItems: 'baseline' }}>
      <p style={{ marginTop: 10 }} className={styles.infoSpan}>
        <ExclamationCircleOutlined style={{ margin: '0px 5px' }} />
        以下为缺断货产品，请与客户沟通，重新选材
      </p>
    </div>
  )
  const fetch = () => {
    return new Promise(async (resolve, reject) => {
      let resData: any = await getListBudgetDtl({
        id: budgetId,
        params: {
          refItemId: refItemId,
        },
      })
      resData = resData.map((item: any, index) => {
        return {
          ...item,
          orderSeq: index + 1,
        }
      })
      console.log(resData, 'resData')
      tableRef.current?.updateDataSource(resData)
    })
  }
  // 删除产品
  const deleteSku = id => {
    SMessage.confirm({
      onOk: () => {
        if (id) {
          return deleteByIdAndBudgetId({
            params: {
              id,
              budgetId,
            },
          }).then((res: any) => {
            message.success(res.message || '操作成功')
            fetch()
          })
        }
      },
    })
  }
  const extension = {
    request: { fetch },
    customSearchRender: () => toolbarTitle,
    pagination: false,
    status: {},
    customRender: {
      renderSku: (text: any, record: any) => {
        const list = record?.budgetDtlVoList || []
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              <>
                {index != 0 && (
                  <Divider
                    style={{ margin: '4px 0', borderBlockStart: '1px dashed rgba(5, 5, 5, 0.06)' }}
                  />
                )}
                <SSkuCard
                  key={index + '-' + record?.id + '-' + item?.id + '-' + item.prdSkuId}
                  width={'100%'}
                  url={
                    item?.mainPic
                      ? item.mainPic.startsWith('http')
                        ? item.mainPic
                        : fileUrlPrefix + item.mainPic
                      : 'https://static.shjmall.cn/sass/empty.png'
                  }
                  urlList={item?.imageUrls}
                  title={
                    <div
                      style={{
                        // color: item?.dynaOptionsWarn == true ? 'red' : 'black',
                        width: '100%',
                      }}
                      className={styles.skuTitle}
                    >
                      {item.name}
                    </div>
                  }
                  imgFit={false}
                  desc={<span className={styles.skuDesc}>{item.prdSkuId}</span>}
                  imgFilter={
                    item?.skuWarnMessage ? (
                      <div dangerouslySetInnerHTML={{ __html: item?.skuWarnMessage }} />
                    ) : undefined
                  }
                  disabled={item?.skuWarnMessage}
                  operation={() => <></>}
                />
              </>
            )
          })
        }
      },
      handleRender: (text: any, record: any) => {
        const list = record?.budgetDtlVoList || []
        if (isArray(list) && !!list?.length) {
          return list.map((item, index) => {
            return (
              <Button
                variant="outlined"
                danger
                onClick={() => {
                  deleteSku(item.id)
                }}
              >
                删除
              </Button>
            )
          })
        }
      },
    },
  }

  return (
    <div>
      <div id="table1">
        <SLowcodeList config={tableConfig} ref={tableRef} {...extension} />
      </div>
    </div>
  )
}
